import React from "react";
import "./Home.css";
const Snow = () => {

    return (
        <>
            <div className="snowflakes" aria-hidden="true">
                <br></br>
                <h1 className="title">Nandhini Devi Madan</h1>
                <p> Web Developer</p>
                {/*   <div className="snowflake">
                    ❅
                </div>
                <div className="snowflake">
                    ❅
                </div>
                <div className="snowflake">
                    ❆
                </div>
                <div className="snowflake">
                    ❄
                </div>
                <div className="snowflake">
                    ❅
                </div>
                <div className="snowflake">
                    ❆
                </div>
                <div className="snowflake">
                    ❄
                </div>
                <div className="snowflake">
                    ❅
                </div>
                <div className="snowflake">
                    ❆
                </div>
                <div className="snowflake">
                    ❄
                </div>
                */}
            </div>
        </>

    )
}

export default Snow;